"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var BaseStyledDialog_1 = __importDefault(require("./BaseStyledDialog"));
var CloseConfirmationDialog = function (props) {
    return (react_1.default.createElement(BaseStyledDialog_1.default, { open: props.open, onClose: props.handleCancel },
        react_1.default.createElement(material_1.DialogTitle, { id: "alert-dialog-title", variant: "h3" }, "Are you sure?"),
        react_1.default.createElement(material_1.DialogContent, null,
            react_1.default.createElement(material_1.DialogContentText, { id: "alert-dialog-description" },
                "You have made changes that have not been saved. If you ",
                props.cancellation ? 'cancel editing' : 'close this dialog',
                " now, these changes will be lost.")),
        react_1.default.createElement(material_1.DialogActions, null,
            react_1.default.createElement(material_1.Button, { onClick: props.handleCancel, variant: "text", color: "secondary" }, "Cancel"),
            react_1.default.createElement(material_1.Button, { onClick: props.handleConfirm, color: "error", variant: "contained" }, "Yes"))));
};
exports.default = CloseConfirmationDialog;
